import { WebhookInstanceRef, WebhookRef } from 'pbts/c1/api/webhooks/v1/webhooks'
import { WebhookInstanceServiceClient, WebhooksSearchClient, WebhooksServiceClient } from 'pbts/c1/api/webhooks/v1/webhooks.client'
import { createMutationApi } from './lib/createMutationApi'
import { createPagedListApi } from './lib/createPagedListApi'
import { createUnaryApi } from './lib/createUnaryApi'

export const listWebhooksApi = createPagedListApi(
    WebhooksServiceClient,
    'list',
    (response) => response.list,
    WebhookRef.typeName,
)

export const createWebhookApi = createMutationApi(
    WebhooksServiceClient,
    'create',
)

export const testWebhookApi = createMutationApi(
    WebhooksServiceClient,
    'test',
)

export const webhookSearchApi = createPagedListApi(
    WebhooksSearchClient,
    'search',
    (response) => response.list,
    WebhookRef.typeName,
)

export const getWebhookApi = createUnaryApi(
    WebhooksServiceClient,
    'get',
)

export const getWebhookPayloadApi = createUnaryApi(
    WebhookInstanceServiceClient,
    'getPayload',
)

export const deleteWebhookApi = createMutationApi(
    WebhooksServiceClient,
    'delete',
)

export const updateWebhookApi = createMutationApi(
    WebhooksServiceClient,
    'update',
)

export const listWebhookInstanceApi = createPagedListApi(
    WebhookInstanceServiceClient,
    'list',
    (response) => response.list,
    WebhookInstanceRef.typeName,
)
